export const TASK_STATES = ["pending", "completed", "closed"] as const;

type TaskState = (typeof TASK_STATES)[number];

export default TaskState;
